import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
    faChevronDown,
    faCommentAltDots,
    faEnvelope,
    faPhone,
    faUserGraduate,
    faUserCog,
    faHeartRate,
    faUniversalAccess,
    faUndo,
    faPencil,
    faMapMarkerAlt,
    faCalendarCheck,
    faMoneyBillWave,
    faBallot,
    faMedkit,
    faHourglass,
    faSignature,
    faTimes,
    faExclamationTriangle,
    faInfoCircle,
    faTrash,
    faPlus,
    faEye,
    faBirthdayCake,
    faCheckDouble,
    faTrophy,
    faClipboardCheck,
    faClipboardList,
    faUserSlash,
    faCheck,
    faIdBadge,
    faUserClock,
    faExclamationCircle,
    faUserShield,
    faMoneyCheck,
    faCalendar,
    faHomeLg,
    faChevronRight
} from '@fortawesome/pro-solid-svg-icons';

import {
    faFlag,
    faFileInvoice,
    faDownload,
    faSave,
    faQuestionCircle,
    faFileImport,
    faVenusMars,
    faAddressCard,
    faCloudUpload,
    faFilePdf,
    faFileImage,
    faFile,
    faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons';

import { 
    faCheckCircle,
    faClipboardListCheck
} from '@fortawesome/pro-light-svg-icons';

import { 
    
} from '@fortawesome/pro-thin-svg-icons';

import {
    faUniversity,
    faDiploma,
    faUserTie,
    faCookieBite,
    faCalendarAlt,
    faArrowCircleLeft,
    faArrowCircleRight
} from '@fortawesome/pro-duotone-svg-icons';

import {
    faGraduationCap,

} from '@fortawesome/sharp-regular-svg-icons';

library.add(
    faChevronDown,
    faCommentAltDots,
    faEnvelope,
    faPhone,
    faUserGraduate,
    faUserTie,
    faUserCog,
    faHeartRate,
    faUniversalAccess,
    faUndo,
    faPencil,
    faMapMarkerAlt,
    faCalendarCheck,
    faMoneyBillWave,
    faBallot,
    faMedkit,
    faHourglass,
    faSignature,
    faTimes,
    faExclamationTriangle,
    faInfoCircle,
    faTrash,
    faPlus,
    faEye,
    faFlag,
    faUniversity,
    faFileInvoice,
    faDownload,
    faSave,
    faInfoCircle,
    faTrash,
    faQuestionCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faFileImport,
    faGraduationCap,
    faUniversity,
    faDiploma,
    faUserTie,
    faCookieBite,
    faCalendarAlt,
    faCalendar, 
    faArrowCircleLeft,
    faArrowCircleRight,
    faBirthdayCake,
    faVenusMars,
    faAddressCard,
    faCheckDouble,
    faTrophy,
    faClipboardCheck,
    faClipboardList,
    faUserSlash,
    faCheck,
    faCloudUpload,
    faIdBadge,
    faUserClock,
    faFilePdf,
    faFileImage,
    faFile,
    faCheckCircle,
    faClipboardListCheck,
    faUserShield,
    faMoneyCheck,
    faHomeLg,
    faChevronRight,
    faTriangleExclamation
);

export default FontAwesomeIcon;
